import type {
  PaperKingdomProject,
  PromptWork,
} from "../domain/schema";

const channelSeparator = "::channel::";

export function getPromptWorkKey(
  promptId: string,
  marketplace: PaperKingdomProject["marketplace"],
) {
  return `${promptId}${channelSeparator}${marketplace}`;
}

export function getPromptIdFromWorkKey(key: string) {
  return key.split(channelSeparator)[0];
}

export function getPromptWorkForChannel(
  project: PaperKingdomProject,
  promptId: string,
): PromptWork | undefined {
  return (
    project.promptWork[getPromptWorkKey(promptId, project.marketplace)] ??
    project.promptWork[promptId]
  );
}

export function getPromptWorkEntriesForChannel(
  project: PaperKingdomProject,
): Array<[string, PromptWork]> {
  const suffix = `${channelSeparator}${project.marketplace}`;
  return Object.entries(project.promptWork).filter(
    ([key]) => !key.includes(channelSeparator) || key.endsWith(suffix),
  );
}

export function scopeLegacyPromptWork(
  promptWork: PaperKingdomProject["promptWork"],
  marketplace: PaperKingdomProject["marketplace"],
) {
  const scoped = { ...promptWork };
  for (const [key, work] of Object.entries(promptWork)) {
    if (key.includes(channelSeparator)) continue;
    scoped[getPromptWorkKey(key, marketplace)] ??= work;
    delete scoped[key];
  }
  return scoped;
}
